<template>
  <v-dialog-old ref="dialog" id="doctorEdit" @hidden="resetComponentData()" :onCloseEsc="onclose">
      <DoctorSpecialitiesDialog ref="specialitiesDialog" v-model="M.specialities_ids" :speciality-options="specialityOptions"/>
      <DoctorDeletionDialog v-if="currentUser.role ==='admin'" ref="deletionDialog" @deleted="hideAndRefresh" :doctor="M"/>
      <DoctorDuplicateDialog ref="duplicateDialog" @onSelectDoctor="onSelectDuplicateDoctor"/>
      <dialog-doctor-moderation ref="doctorModerate" @updated="hideAndRefresh"/>
    <image-cropper
        ref="cropper"
        :img="M.img"
        type="doctors"
        width="150"
        height="225"
        @canceled="cropCanceled"
        @crop-upload-success="cropUploadSuccess"
        upload-url="/imageCropperNew/doctors"
    />

    <a href="#close" style="text-align: center" @click.stop.prevent="onclose"></a>
    <ValidationObserver ref="doctorEditForm">
      <form>
        <div v-if="M.moderationNeeded && currentUser.role !== 'admin'" style="margin-right: 3px;" class="alert alert-warning">
          Внимание! Изменения отправлены на проверку.<br/>
          После проверки менеджером обновлённая информация появится на сайте.
        </div>
        <fieldset :disabled="disableFields" style="width:100%;overflow: initial !important;">
          <legend>Общая информация</legend>
          <table class="grid">
            <tr>
              <td :rowspan="currentUser.role ==='network' ? 5 : 4" width="160" valign="top" style="padding-right: 10px">
                <drag-and-drop @fileDropped="openCropWithNewFile">
                  <div class="imageCropper">
                    <button type="button" v-show="M.img !== ''"
                            class="resetBtn small redHover" tooltip="Удалить"
                            @click.prevent.stop="imageCropperDelete">
                      <i class="fas fa-trash"></i>
                    </button>
                    <img src="" class="avatar"
                         :src="M.img ? storagePublicUrl + '/images/doctors/150x225/' + M.img : ''"
                         width="150" height="225" @click.prevent.stop="imageCropperOpen"
                         style="cursor: pointer;"
                         :style="M.sex === 'FEMALE' ? 'background-image:url(/_assets/pic_she.svg)' : 'background-image:url(/_assets/pic_he.svg)'"
                    />

                    <i class="button small" @click.prevent.stop="openDoctorPage"
                       width="150"
                       v-tooltip="`${$parent.$parent.frontendUrl}/${M.bestCityCharId}/doctor/${M.url}`"
                       :disabled="!M.id" style="margin: 5px 0 !important; width: 100%"
                    >
                      <i class="fas fa-link"/>
                      Показать на сайте
                    </i>
                  </div>
                </drag-and-drop>
              </td>

              <td>
                <label>Фамилия</label>
                <vee-input ref="family"
                           v-if="currentUser.role === 'admin' || actionType === 'create'"
                           input-class="large"
                           type="text"
                           v-model="M.nameFamily"
                           @paste="onPasteFamilyName"
                           @blur="onBlurFio($event)"
                           :v-beautify="'capitalize'"
                           rules="required"
                           autofocus
                />
                <b v-else :class="{networkFIO: currentUser.role ==='network'}" style="font-size: 24px">{{ M.nameFamily }}</b>
              </td>
            </tr>

            <tr>
              <td>
                <label>Имя</label>
                <vee-input v-if="currentUser.role === 'admin'|| actionType === 'create'"
                           input-class="large"
                           type="text"
                           v-model="M.nameFirst"
                           @blur="onBlurFio($event)"
                           rules="required"
                           :v-beautify="'capitalize'"/>
                <b v-else :class="{networkFIO: currentUser.role ==='network'}" style="font-size: 24px">{{ M.nameFirst }}</b>
              </td>
            </tr>

            <tr>
              <td>
                <label>Отчество</label>
                <vee-input v-if="currentUser.role === 'admin'|| actionType === 'create'"
                           input-class="large"
                           type="text"
                           v-model="M.nameFathers"
                           @blur="onBlurFio($event)"
                           :v-beautify="'capitalize'"/>
                <b v-else :class="{networkFIO: currentUser.role ==='network'}" style="font-size: 24px">{{ M.nameFathers }}</b>
              </td>
            </tr>

            <tr>
              <td>
                <label>Специализация</label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="textarea"
                       v-tooltip="{
                                    content: errors[0],
                                    template: $errTemplate,
                                 }"
                       :class="{ 'hasError': errors[0]}" v-model="M.specialities_ids">
                              <span class="comma">
                                  <span v-for="spec in M.specialities_ids">{{ getSpecName(spec)}}</span>
                              </span>
                    <button @click.prevent="editSpecialities" class="tiny">Выбрать специализации</button>
                  </div>
                </ValidationProvider>
              </td>
            </tr>

            <tr>
              <td v-if="currentUser.role === 'admin' && actionType === 'update'" style="padding-right: 10px">
                <label>Рейтинг&nbsp;внутренний</label>
                <input :value="M.ratingInternal" readonly v-tooltip="{content: infoTooltip}"/>
              </td>
              <td v-if="currentUser.role === 'admin' && actionType === 'create'" style="padding-right: 10px"></td>
              <td v-if="currentUser.role === 'clinics'" style="padding-right: 10px">
                <label>Консультация</label>
                <vee-input style="text-align: right;" :rules="{max: 7, min_value: 0}" v-model="M.price" utils-literal="руб"/>
              </td>
              <td>
                <table class="grid">
                  <tr>
                    <td width="16.66%">
                      <label>Степень</label>
                      <v-select
                          v-model="M.degree"
                          :options='[
                                                { value: "", text: "\u00a0" },
                                                { value: "NONE", text: "Нет степени" },
                                                { value: "KMN", text: "Кандидат наук" },
                                                { value: "DMN", text: "Доктор наук" },
                                           ]'
                      />
                    </td>
                    <td width="16.66%">
                      <label>Категория</label>
                      <v-select
                          v-model="M.category"
                          :options='[
                                                { value: "", text: "\u00a0" },
                                                { value: "NONE", text: "Нет" },
                                                { value: "FIRST", text: "Первая" },
                                                { value: "SECOND", text: "Вторая" },
                                                { value: "TOP", text: "Высшая" },
                                            ]'
                      />
                    </td>
                    <td width="16.66%">
                      <label>Звание</label>
                      <v-select
                          v-model="M.rank"
                          :options='[
                                                { value: "", text: "\u00a0" },
                                                { value: "NONE", text: "Нет звания" },
                                                { value: "PROFESSOR", text: "Профессор" },
                                                { value: "DOCENT", text: "Доцент" },
                                            ]'
                      />
                    </td>
                    <td width="16.66%">
                      <label>Стаж</label>
                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="numeric|max_value:100|min_value:0"
                        >
                            <input
                                type="number"
                                v-model="M.experience"
                                v-units.literal="`лет`"
                                min="0" max="100"
                                style="text-align: right !important;"
                                name="«Стаж»"
                                :class="{'hasError' : errors[0]}"
                                v-tooltip="{
                                           content: errors[0],
                                           template: $errTemplate,
                                       }"
                            />
                        </ValidationProvider>

                    </td>
                    <td width="16.66%">
                      <label>Пол</label>
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <v-select
                            v-model="M.sex"
                            :class="{'hasError': errors[0]}"
                            v-tooltip.right="{content: errors[0], template: $errTemplate}"
                            :options='[
                                                  { value: "MALE", text: "Мужской" },
                                                  { value: "FEMALE", text: "Женский" }
                                              ]'
                        />
                      </ValidationProvider>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </fieldset>

        <fieldset :disabled="disableFields">
          <legend>Информация о враче</legend>
          <v-quill ref="quill" v-model="M.info" placeholder="Описание" :config="quillConfig"/>
        </fieldset>

        <fieldset :disabled="disableFields" style="width:100%;overflow: initial !important;">
          <legend>Образование</legend>

          <table class="grid">
            <tbody v-for="(row, index) in M.education" :id="'educationTB_' + index" class="hover">
            <tr>
              <td colspan="2" style="vertical-align: top;">
                <EducationSelect :item="row.univercity"
                                 @selected="(newVal) => onEducationSelect(newVal, index)"
                                 @paste="(text) => onEducationPaste(text, index)"
                                 ref="univercity"/>
              </td>
              <td width="100" style="vertical-align: top;">
                  <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{numeric:true, min_value:1900, max_value:currentYear}"
                  >
                    <input v-model="row.year" placeholder="Год" type="number" min="1900" :max="currentYear"
                           @input="inputEducation" v-units.literal="`г`" style="text-align: left !important;"

                           name="«Год»"
                           :class="{'hasError' : errors[0]}"
                           v-tooltip="{
                               content: errors[0],
                               template: $errTemplate,
                            }"
                    />
                  </ValidationProvider>

              </td>
            </tr>
            <tr style="margin-bottom: 5px">
              <td>
                <input v-model="row.speciality"
                       placeholder="Специальность"
                       class="educationSpeciality"
                       v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                       ref="speciality"
                       @input="inputEducation"
                       @paste="onPasteSpeciality(index, $event)">
              </td>
              <td style="width: 360px">
                <v-select
                    v-model="row.grade"
                    @select="e => onEducationGradeSelect(e, index)"
                    ref="grade"
                    :options='[
                                { value: "", text: "\u00a0" },
                                { value: "базовое образование", text: "базовое образование" },
                                { value: "интернатура", text: "интернатура" },
                                { value: "ординатура", text: "ординатура" },
                                { value: "аспирантура", text: "аспирантура" },
                                { value: "докторантура", text: "докторантура" },
                            ]'
                />
              </td>
              <td width="100" align="right">
                <button v-if="currentUser.role === 'admin'" class="small blueHover" @click.prevent="moveEducationToCertificates(index)" tabindex="-1"
                        v-tooltip="'Перенести в курсы и сертификаты'"
                >→Курс
                </button>
                <button class="small redHover square" @click.prevent="removeEducation(index)" tabindex="-1">
                  <i class="far fa-trash-can"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="6">
                <button class="small" @click.prevent="addEducation(true)" tabindex="-1">Добавить образование</button>
              </td>
            </tr>
            </tfoot>
          </table>
        </fieldset>

        <fieldset :disabled="disableFields">
          <legend>Курсы и сертификаты</legend>

          <table class="grid">
            <tbody v-for="(row, certRowIndex) in M.certificates" class="hover">
            <tr>
              <td valign="top">
                <input type="text"
                       ref="cert"
                       v-model="row.univercity"
                       class="certificateName"
                       @paste="onPasteCertificates(certRowIndex, $event)"
                       @input="inputCertificate(certRowIndex)"
                       v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                       placeholder="Название курса или сертификата">
              </td>
            </tr>
            <tr>
              <td>
                            <span class="certificateYearBlock" v-for="(y,i) in row.year" track-by="$index">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{numeric:true, min_value:1900, max_value:currentYear}"
                                >
                                    <input v-model="row.year[i]" @keyup="inputCertificateYear(certRowIndex)"
                                           @click.prevent="inputCertificateYear(certRowIndex)" placeholder="Год"
                                           type="number"
                                           min="1900" :max="currentYear" v-units.literal="`г`"
                                           style="width: 70px; text-align: left !important;"
                                           @blur="arrangeCertificates"

                                           name="«Год»"
                                           :class="{'hasError' : errors[0]}"
                                           v-tooltip="{
                                               content: errors[0],
                                               template: $errTemplate,
                                            }"
                                    >
                                </ValidationProvider>
                                <button class="small redHover square"
                                        @click.prevent="removeCertificateYear(certRowIndex, i)" tabindex="-1"><i
                                    class="far fa-trash-can"></i></button>
                            </span>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="6">
                <button class="small" @click.prevent="addCertificate(true)" tabindex="-1">Добавить курс или сертификат
                </button>
              </td>
            </tr>
            </tfoot>
          </table>
        </fieldset>


          <fieldset :disabled="disableFields" style="width:100%;overflow: initial !important;">
              <legend>Опыт работы</legend>

              <table class="grid employments">
                  <tbody v-for="(row, emplRowIndex) in M.employment" class="hover">
                  <tr>
                      <td colspan="8">
                          <input v-model="row.name"
                                 ref="employment"
                                 placeholder="Место работы"
                                 class="employmentName"
                                 @input="inputEmployment"
                                 @paste="onPasteEmployments(emplRowIndex, $event)"
                                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'">
                      </td>
                  </tr>
                  <tr>
                      <td style="width: 300px">
                          <input v-model="row.position"
                                 placeholder="Должность"
                                 class="employmentPosition"
                                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                                 ref="position"
                                 @paste="onPastePosition(emplRowIndex, $event)"
                                 @input="inputEmployment">
                      </td>
                      <td style="width: 80px">
                          <v-select
                              v-model="row.m1"
                              placeholder="Мес" @close="inputEmployment(true)"
                              :options='[
                                { value: "", text: "\u00a0" },
                                { value: "1", text: "Янв" },
                                { value: "2", text: "Фев" },
                                { value: "3", text: "Март" },
                                { value: "4", text: "Апр" },
                                { value: "5", text: "Май" },
                                { value: "6", text: "Июнь" },
                                { value: "7", text: "Июль" },
                                { value: "8", text: "Авг" },
                                { value: "9", text: "Сен" },
                                { value: "10", text: "Окт" },
                                { value: "11", text: "Ноя" },
                                { value: "12", text: "Дек" },
                            ]'
                          />
                      </td>
                      <td style="width: 80px">
                          <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{numeric:true, min_value:1900, max_value:currentYear}"
                          >
                              <input v-model="row.y1" placeholder="Год" type="number" min="1900"
                                     :max="currentYear" @input="inputEducation" v-units.literal="`г`"
                                     style="text-align: left !important;"
                                     :required="(row.m1 != '')"
                                     @blur="validateEmploymentDates"

                                     name="«Год»"
                                     :class="{'hasError' : errors[0]}"
                                     v-tooltip="{
                                       content: errors[0],
                                       template: $errTemplate,
                                    }"
                              />
                          </ValidationProvider>
                      </td>
                      <td width="30" align="center">по</td>
                      <td style="width: 80px">
                          <v-select
                              v-model="row.m2" :disabled="row.now"
                              placeholder="Мес" @close="inputEmployment(true)"
                              :options='[
                                { value: "", text: "\u00a0" },
                                { value: "1", text: "Янв" },
                                { value: "2", text: "Фев" },
                                { value: "3", text: "Март" },
                                { value: "4", text: "Апр" },
                                { value: "5", text: "Май" },
                                { value: "6", text: "Июнь" },
                                { value: "7", text: "Июль" },
                                { value: "8", text: "Авг" },
                                { value: "9", text: "Сен" },
                                { value: "10", text: "Окт" },
                                { value: "11", text: "Ноя" },
                                { value: "12", text: "Дек" },
                            ]'
                          />
                      </td>
                      <td style="width: 80px">
                          <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{numeric:true, min_value:1900, max_value:currentYear}"
                          >
                          <input v-model="row.y2" placeholder="Год" type="number" min="1900"
                                 :max="currentYear" @input="inputEducation" v-units.literal="`г`"
                                 style="text-align: left !important;" :disabled="row.now" class="year2"
                                 :required="(row.m2 != '')" @blur="validateEmploymentDates"

                                 name="«Год»"
                                 :class="{'hasError' : errors[0]}"
                                 v-tooltip="{
                                       content: errors[0],
                                       template: $errTemplate,
                                    }"
                          />
                          </ValidationProvider>
                      </td>
                      <td width="160">
                          <label>
                              <input type="checkbox" v-model="row.now" @change="inputEmployment">
                              <span>по&nbsp;наст.&nbsp;время</span>
                          </label>
                      </td>
                      <td style="width: 30px" align="right">
                          <button class="small redHover square" @click.prevent="removeEmployment(emplRowIndex)" tabindex="-1"><i
                              class="far fa-trash-can"></i></button>
                      </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                      <td colspan="6">
                          <button class="small" @click.prevent="addEmployment(true)" tabindex="-1">Добавить место работы</button>
                      </td>
                  </tr>
                  </tfoot>
              </table>
          </fieldset>

          <fieldset :disabled="disableFields">
          <legend>Член ассоциации врачей</legend>

          <table class="grid">
            <tr v-for="(row, assocRowIndex) in M.associations" track-by="$index">
              <td>
                <input v-model="M.associations[assocRowIndex]"
                       ref="association"
                       class="associationName"
                       @input="inputAssociation(assocRowIndex)"
                       @paste="onPasteAssociations(assocRowIndex, $event)"
                       v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                       placeholder="Название ассоциации"/>
              </td>
              <td width="40" align="right">
                <button class="small redHover square" @click.prevent="removeAssociation(assocRowIndex)" tabindex="-1"><i
                    class="far fa-trash-can"></i></button>
              </td>
            </tr>
            <tfoot>
            <tr>
              <td colspan="2">
                <button class="small" @click.prevent="addAssociation(true)" tabindex="-1">Добавить ассоциацию</button>
              </td>
            </tr>
            </tfoot>
          </table>
        </fieldset>

        <fieldset :disabled="disableFields" class="photosResult">
            <legend>Фотографии</legend>

            <photo-gallery
                id="photos"
                v-model="M.photos"
                :imagesBasePath="storagePublicUrl + '/images/doctorPhotos/120x120/'"
                uploadUrl="doctors/uploadPhoto"
                buttonText="Добавить<br>фотографии<br>врача"
                @file-uploaded="photosUploaded"
                :doctor.sync="M"
                :is-doctor="true"
            ></photo-gallery>

        </fieldset>

        <fieldset v-if="currentUser.role === 'admin'" style="overflow:visible;width:100%">
          <legend>Место приема</legend>
          <ValidationProvider vid="clinics" style="width: 100%" name="Поиск по клиникам..."
                              :rules="{required: M.clinics.length === 0}" v-slot="{ errors }">
            <v-select
                style="width: 100%"
                :class="{ 'hasError': errors[0]}"
                v-tooltip.right="{
                                        content: errors[0],
                                        template: $errTemplate,
                                    }"
                :options="foundClinics"
                @search-change="findClinics"
                v-on:remove="addLink"
                placeholder="Поиск клиник...">
              <template v-slot="{ option }">
                <div class="textarea">
                  <span>{{ option.text }}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span v-if="option.networkName !== null" class="label bg-red">
                                                    {{ option.networkName }}
                                                </span><br>
                  <small>{{ option.cityName+', '+option.address }}</small>
                </div>
              </template>
            </v-select>
          </ValidationProvider>
          <table class="grid">
            <tbody v-for="(clinic, index) in M.clinics" class="hover">
            <tr :class="{onmoderation: clinic.moderationNeeded, del: clinic.link_deleted}">
              <td style="white-space: nowrap;">{{ clinic.cityObj.name }}</td>
              <td width="20" align="center">
                <i class="fa fa-book"
                   :class="[clinic.hasAbonSubscription && clinic.deleted_at === null ? 'text-success' : 'text-danger']"
                   v-tooltip="{content: clinic.hasAbonSubscription ? 'Есть запись' : 'Нет записи'}"
                ></i>
              </td>
              <td>
                {{ clinic.name }}
                <span class="comma brackets">
                            <span v-if="clinic.deleted_at !== null">клиника удалена</span>
                            <span v-if="!clinic.hasAbonSubscription">нет&nbsp;записи</span>
                        </span>
              </td>

              <td width="100">
                <input v-model="clinic.price" min="0" v-units.literal="'руб'"
                       :invalid="!((clinic.price === '') || (clinic.price >= 0 && clinic.price <= 50000))"
                       style="text-align: right"/>
              </td>
              <td v-if="clinic.deleted_at === null" width="30" align="right">
                <button v-if="clinic.link_deleted" class='small greenHover square' tooltip='Добавить' @click.prevent="removeLinkToggle(index)" tabindex="-1">
                  <i class="far fa-plus"></i>
                </button>
                <button v-else class='small redHover square' tooltip='Удалить' @click.prevent="removeLinkToggle(index)" tabindex="-1">
                  <i class="far fa-trash-can"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </fieldset>
        <fieldset v-if="currentUser.role === 'network'" style="overflow:visible;width:100%">
          <legend>Места приема</legend>
          <table v-if="M.networkClinics" class="grid" :class="{attentionValidationOnSubmitError: showInvalidClinics}">
            <tr v-for="row in M.networkClinics">
              <td>
                <label>
                  <input :disabled="disableNetLinksEdit" type="checkbox" v-model="row.checked">
                  <span>{{row.name}}</span>
                  <br>
                  <span style="font-size: 14px; color: #000; margin-left: 22px;">
                    {{ row.cityName ? (row.cityName + ', ' + row.address) : row.address }}
                  </span>
                </label>
              </td>
              <td width="100">
                <vee-input :disabled="!row.checked" type="text" customStyle="text-align: right"
                           v-model="row.price" utils-literal="руб"
                           :rules="{max_value: 50000, min_value: 0}"
                />
              </td>
            </tr>
          </table>
        </fieldset>
      </form>
    </ValidationObserver>
    <footer v-if="!disableFields">
      <v-loading-component @click="onUpdate">
        <template slot-scope="{ loadingClass }">
          <button :disabled="!needSave" :class="[{green: needSave}, loadingClass]">Сохранить</button>
        </template>
      </v-loading-component>
      <v-loading-component v-if="actionType !== 'create' && $can('admin.doctors.merge')" @click="mergeDoctors">
        <template slot-scope="{ loadingClass }">
          <button :class="['orangeHover', loadingClass]">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHiSURBVGhD7Zm7TsMwFEALA/AxjIyMSPwDIwMjjy9B7IgfgBUYGPkOBhYEAzMTj3vaXsmy7hV2GstO5SMd0ZK0yVGcxGpmnU6nszZcik+F3RWL8yz+FnZfLM5ahlyLJyP5KVYLOeIfI/Eq9pAhpIRsLP/m0FzIsfggbs/fpdNUCBE/IssexTCGo3SxeGnSTAg7ypHQZagxLONGys56NHVE2Gl2Xpcj76+WrycTAlaMOqkQ8GJSQ87Fgwz3xGxSQjgndDiFeiFb4rsYr58q+5TNfyF6YocbUr2QO9FaP9UiIafii6O3wUPxS+Q730Trs7EfYtGQVHZEojfn7xYxtyLDLAW2XT2ECL0Y3Igak0P1kDBCPRNzqR7CcNLPI1HhVCaV6iEMI4bTKhFQJYQTmBOZExqIYTgNjYBRQ7gEWpfGWC6prM8lVmNi+F7rs8hwjBk1ZIgcGYtwihLKzdWiagjTEO8+YYUwzfFYOYQJmjVx82QCqBv0pihghXAx4HJtsXJILkzJdYO5IejFNB/CcIpvmFZM0yF6Ylt3/3uRmbXSbEj8w0QY8y3yw0ZIsyEWxHAk4giYVAiEwylkciEePWQoYQiPDqxHCkPkkUa1kFL2kBx4sGk98BxTb4bc6XQ6k2I2+wOpaR7aXP2juAAAAABJRU5ErkJggg==" width="25" height="25">
          </button>
        </template>
      </v-loading-component>
      <v-loading-component v-if="actionType !== 'create'" @click="onDelete">
        <template slot-scope="{ loadingClass }">
          <button :class="['redHover', loadingClass]"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFwSURBVGhD7ZmtSgVRFIVHBDEIahMUX0AFg8EgWHwEQRCsPoAWq8Fg1SCCVYuCJvEHk8VkEGwWX8AsFl0L9oaDHPHOZZ87w2V98JXFMPssmDn3cqYSQggBpuEBvIH3Ge/gMZyFrWUSfsDvDvyE87CV7MHcov/yDLaSS+iLPIWbGQ+hX/MMe8oAHO/AW+iL3Lbst2vQr3m17D8HYQij0Ic34RwMQUWCDCvi78gu9JufWxZtbkbYO+LsQB/CXakEvZihInVotMgYXDGXGCR4TocZGAvQ8wkGRqNFuHjP3xkkeE75h9J5hJ6vMzBUpA4qYqpINCpiqkg0KmKqSDQqYqpINCpitr7IIuSZL31hkOA5nWJgXEPPVxkYjRaJREXq0DdFeDDtQx4YFOAE+gye3BdhGfoQegRznw66dR9+Qb//BiwCj06fYFqmlG8wPT4Kh1sot9jc8Cj5WzQDizME+ShcwNwHz269gltwBAohRF9SVT/YcCJDemJ9EwAAAABJRU5ErkJggg==" width="25" height="25">
          </button>
        </template>
      </v-loading-component>
    </footer>
  </v-dialog-old>
</template>

<script>
import Vue from "vue";
import {validation} from "@base/validation";
import DialogDoctorModeration from '@dialogs/admin/doctorModeration/Dialog'
import DoctorSpecialitiesDialog from "./DoctorSpecialitiesDialog";
import DoctorDeletionDialog from "./DoctorDeletionDialog";
import DoctorDuplicateDialog from "./DoctorDuplicateDialog";
import imageCropper from '@base/ImageCropper.vue';
import {mapState} from "vuex";
import dragAndDrop from '@base/DragAndDrop.vue';
import {STORAGE_PUBLIC} from "@global/const";
import {initialState, GET_DEFAULT_M} from "./DoctorEditFields";
import _ from "lodash";
import EducationSelect from "./EducationSelect";
import PhotoGallery from "@common/PhotoGallery";

export default {
  components: {
    dragAndDrop,
    imageCropper,
    DoctorSpecialitiesDialog,
    DoctorDuplicateDialog,
    DialogDoctorModeration,
    DoctorDeletionDialog,
    EducationSelect,
    PhotoGallery
  },
  props: {
    networkClinics: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
  },
  data() {
    return initialState();
  },
  mounted() {
    this.$store.dispatch('dictionary/fetchDeletionReasonsOptions');
    this.$store.dispatch('dictionary/fetchSpecialityOptions');

    setTimeout(() => {
      document.querySelectorAll('.educationSpeciality')
          .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
      document.querySelectorAll('.certificateName')
          .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
      document.querySelectorAll('.employmentName')
          .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
      document.querySelectorAll('.employmentPosition')
          .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
      document.querySelectorAll('.associationName')
          .forEach(el => el.dispatchEvent(new Event('blur', { bubbles: true })));
    }, 100);
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      specialityOptions: state => state.dictionary.specialityOptions,
    }),
    storagePublicUrl() {
      return STORAGE_PUBLIC;
    },
    showInvalidClinics () {
      return this.netInvalidShowFlag && this.M.networkClinics.filter((item) => item.checked === true).length === 0;
    },
    disableFields() {
      return this.M.moderationNeeded && this.currentUser.isSupport;
    },
    disableNetLinksEdit() {
      if(this.actionType === 'create'){
        return false;
      }
      if (this.currentUser.isSupport && this.M.moderationNeeded ){
        return true;
      }
      if (this.M.url !== "") {
        return false;
      }

      return this.M.url === "" && !(this.M.nameFamily !== "" && this.M.nameFirst !== "");
    },
    currentYear() {
      return new Date().getFullYear() ?? 2400;
    },
    quillConfig() {
      let scope = this;
      let container = this.currentUser.role === 'admin' ? [
        [
          {'list': 'bullet'}, 'clean',
          'textLowerCase', 'textToEducations', 'textToEmployments', 'textToCertificates',  'textToAssociations'
        ],
        ['textTemplate1']
      ] : [{'list': 'bullet'}, 'clean'];

      return {
        customEvents: {
          onTextChange: (quill, delta, oldDelta, source) => {

            var listChanged = delta
                .filter((op) => (op.attributes || {}).list === "bullet")
                .length;

            if (listChanged) {
              var deltaBefore = quill.getContents();
              var deltaNew = new Delta();
              deltaBefore.eachLine((line, attr, i) => {
                var d = line;
                if (attr.list === 'bullet') {
                  var dText = d
                      .filter((op) => typeof op.insert === 'string')
                      .map((op) => op.insert)
                      .join('');

                  var prefix = dText.match(/^([-*•·▪▫‣◦+—.)\s]|(\d{1,2}[\)\.]))+/ig) || [''];
                  d = d.slice(prefix[0].length);
                }

                d.insert('\n', attr);
                deltaNew = deltaNew.concat(d);
              });
              quill.updateContents(deltaBefore.diff(deltaNew), 'api');
            }
          }
        },
        modules: {
          toolbar: {
            container: container,

            handlers: {
              textToEducations() {
                let range = this.quill.getSelection();
                if (range.length) {
                  let text = this.quill.getText(range.index, range.length);
                  this.quill.deleteText(range.index, range.length, 'api');
                  this.quill.setSelection(range.index, 0);

                  let index = null;
                    scope.$refs.univercity.forEach((item, i) => {
                      if (!item.$attrs.value && index === null) {
                        index = i;
                      }
                  })

                  scope.textToEducations(text, index, true);
                  if (index === null || index === scope.$refs.univercity.length - 1) {
                    scope.addEducation();
                  }
                }
              },
              textToCertificates() {
                let range = this.quill.getSelection();
                if (range.length) {
                  let text = this.quill.getText(range.index, range.length);
                  this.quill.deleteText(range.index, range.length, 'api');
                  this.quill.setSelection(range.index, 0);

                  scope.textToCertificates(text, null, true);
                  scope.addCertificate();
                }
              },
              textToEmployments: function () {
                let range = this.quill.getSelection();
                if (range.length) {
                  let text = this.quill.getText(range.index, range.length);
                  this.quill.deleteText(range.index, range.length, 'api');
                  this.quill.setSelection(range.index, 0);

                  scope.textToEmployments(text, null, true);
                }
              },
              textToAssociations: function () {
                let range = this.quill.getSelection();
                if (range.length) {
                  var text = this.quill.getText(range.index, range.length);
                  this.quill.deleteText(range.index, range.length, 'api');
                  this.quill.setSelection(range.index, 0);

                  scope.textToAssociations(text, null, true);
                  scope.addAssociation();
                }
              },
              textLowerCase: function () {
                let range = this.quill.getSelection();
                if (range.length) {
                  var text = this.quill.getText(range.index, range.length);
                  text = text.toLowerCase();
                  this.quill.deleteText(range.index, range.length, 'api');
                  this.quill.insertText(range.index, text, 'api');
                  this.quill.setSelection(range.index + text.length, 0);
                }
              },
              textTemplate1: function () {
                let text = 'Профессиональные навыки: ';
                let range = this.quill.getSelection();
                if (range.length) {
                  this.quill.deleteText(range.index, range.length, 'api');
                }
                this.quill.insertText(range.index, text, 'api');
                this.quill.setSelection(range.index + text.length, 0);
              },
            }
          },
        },
        eventsOnBlur: true,
      };
    },
      needSave: function () {
          return (this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.M).hashCode())) ||
              this.actionType === 'create' ||
              this.currentUser.role === 'admin' ||
              this.isDuplicate;
      },
  },
    watch:{
        needSave(val, oldVal) {
            if (val && !(this.actionType === 'create' || this.currentUser.role === 'admin')) {
                window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
            } else {
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
            }

        },
        M: {
            handler(value) {
                setTimeout(() => {
                    if (value.newImgFile && !this.$refs.cropper.$refs.dialog.visible) {
                        this.openCropWithNewFile(value.newImgFile);
                    }
                }, 2000)
            },
            deep: true
        }
    },
  methods: {
    onEducationSelect(value, index) {
      this.M.education[index].univercity = value;

      this.inputEducation();
    },
    onEducationPaste(text, index) {
      text = this.cutQuotes(text);
      text = text.trim();

      if (text) {
        let data = this.parseEducation(text);

        if (!this.M.education[index].year) {
          this.M.education[index].year = data.year;
        }
        if (!this.M.education[index].speciality) {
          this.M.education[index].speciality = data.speciality;
        }
        if (!this.M.education[index].grade) {
          this.M.education[index].grade = data.grade;
        }
      }
    },
    create() {
        this.resetComponentData();
      this.actionType = 'create';

      if(this.currentUser.role === 'network') {
        this.M.networkClinics = JSON.parse(JSON.stringify(this.networkClinics))
      }else{
        delete(this.M.networkClinics);
      }
      this.M_clone = JSON.parse(JSON.stringify(this.M));
      this.$refs.dialog.show();
      setTimeout(() => {
        this.$refs.family.$refs.input.focus();
      }, 225)
    },
    openDoctorPage() {
      window.open('https://doctu.ru/' + this.M.bestCityCharId + '/doctor/' + this.M.url, '_blank');
    },
    getSpecName(spec) {
      let specFoundObj = this.specialityOptions.find(item => item.value === spec)

      if(specFoundObj) {
        return specFoundObj.text
      }
      return '';
    },
    mergeDoctors (btn) {
        btn.startLoadingAnimation();
        this.$refs.doctorEditForm.validate().then(success => {
            if (!success) {
                const el = document.querySelector(".hasError:first-of-type");
                el.scrollIntoView({behavior: "smooth"});
                btn.stopLoadingAnimation()
                return;
            }
            this.axios.post('doctors/update/' + this.M.id, this.M).then(() => {
                this.$refs.doctorModerate.showModal(this.M.id, false, 'MERGE')
                btn.stopLoadingAnimation()
            }).catch((error) => {
            });
        })
    },

    findClinicByName (name) {
      this.clinicSearchRequest = this.axios.CancelToken.source();

      return this.axios.post('/clinicsAutocomplete', {
        q: name, filter: {
          excludeIds: this.M.clinics.map((clinic) => {return clinic.id})
        }
      }, {
          cancelToken: this.clinicSearchRequest.token
      });
    },
    findClinics: function (query) {
      if (this.clinicSearchRequest) {
        this.clinicSearchRequest.cancel();
      }
      if (query.length > 2) {
        this.findClinicByName(query).then(res => {
          this.foundClinics = res.data.suggestions.map(item => {
            return {
              id: item.data.id,
              account_id: item.data.account_id,
              text: item.data.name,
              cityName: item.data.cityName,
              networkName: item.data.networkName,
              address: item.data.address,
              children: item.data.children,
            }
          })
        })
      } else {
        this.foundClinics = [];
      }
    },
    removeLinkToggle: function (index) {
      if (this.M.clinics[index].isNew === true) {
        this.M.clinics.splice(index, 1)// удаляем если не была сохранена

      } else {
        this.M.clinics[index].link_deleted = !this.M.clinics[index].link_deleted;
      }
    },
    addLink: function (payload) {
      this.M.clinics.push({
        id: payload.id,
        name: payload.text,
          cityObj: {
          name: payload.cityName,
        },
        address: payload.address,
        moderationNeeded: false,
        hasAbonSubscription: false,
        link_deleted_at: null,
        isNew: true,
        price: '',
        priceOld: '',
        priceNew: '',
        deleted_at: null,
        link_deleted: false
      });
      this.$nextTick(function () {
        this.$refs.doctorEditForm.validate();
      });
    },
    parseEducation(line) {
      let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          if (acc === '') {
              let y = parseInt(val);
              if ((1970 <= y && y <= 2030)) {
                  return y;
              } else if ((70 <= y && y <= 99)) {
                  return 1900 + y;
              }
          }
          return acc;
      }, '');

      let speciality = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          if (acc === '') {
              val = val.toLowerCase();

              if (val.startsWith('лечебн')) {
                  return 'Лечебное дело';

              } else if (val.startsWith('педиатр')) {
                  return 'Педиатрия';

              } else if (val.startsWith('стоматолог')) {
                  return 'Стоматология';

              } else if (val.startsWith('акушер')) {
                  return 'Акушерство и гинекология';

              } else if (val.startsWith('гинеколог')) {
                  return 'Гинекология';

              } else if (val.startsWith('терап')) {
                  return 'Терапия';

              } else if (val.startsWith('хирург')) {
                  return 'Хирургия';

              } else if (val.startsWith('невролог')) {
                  return 'Неврология';

              } else if (val.startsWith('дерматовенерол')) {
                  return 'Дерматовенерология';

              } else if (val.startsWith('офтальмолог')) {
                  return 'Офтальмология';

              } else if (val.startsWith('уролог')) {
                  return 'Урология';

              } else if (val.startsWith('психолог')) {
                  return 'Психология';

              } else if (val.startsWith('фельдшер')) {
                  return 'Фельдшер';

              } else if (val.startsWith('зубной')) {
                  return 'Стоматология';

              } else if (val.startsWith('общей')) {
                  return 'Врач общей практики';

              } else if (val.startsWith('эндокринолог')) {
                  return 'Эндокринология';

              } else if (val.startsWith('кардиолог')) {
                  return 'Кардиология';

              } else if (val.startsWith('психиатр')) {
                  return 'Психиатрия';

              } else if (val.startsWith('оториноларинголог')) {
                  return 'Оториноларингология';

              } else if (val.startsWith('рентгенолог')) {
                  return 'Рентгенология';

              } else if (val.startsWith('терапевт')) {
                  return 'Терапевт';

              } else if (val.startsWith('логопед')) {
                  return 'Логопедия';

              } else if (val.startsWith('брат')) {
                  return 'Медицинский брат';

              } else if (val.startsWith('сестр')) {
                  return 'Сестринское дело';

              } else if (val.startsWith('массаж')) {
                  return 'Медицинский массаж';

              } else if (val.startsWith('онколог')) {
                  return 'Онкология';

              } else if (val.startsWith('дефектолог')) {
                  return 'Дефектология';

              } else if (val.startsWith('отоларинголог')) {
                  return 'Отоларингология';

              }
          }
          return acc;
      }, '');

      let grade = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          if (acc === '') {
              val = val.toLowerCase();

              if (val.startsWith('интерн')) {
                  return 'интернатура';

              } else if (val.startsWith('ординат')) {
                  return 'ординатура';

              } else if (val.startsWith('аспирант')) {
                  return 'аспирантура';

              } else if (val.startsWith('доктор')) {
                  return 'докторантура';
              }
          }
          return acc;
      }, '');

      let university = this.cutLastComma(_.upperFirst(line).trim());

      return {
          univercity: university,
          year: year,
          speciality: speciality,
          grade: grade
      };
    },
    handleEducationLine(line, index) {
      let data = this.parseEducation(line);

      if (index === null) {
          // добавляем в конец если не задан индекс
          if (
              !!(this.M.education[this.M.education.length - 1]) &&
              _.isEmpty(this.M.education[this.M.education.length - 1].univercity) &&
              _.isEmpty(this.M.education[this.M.education.length - 1].year) &&
              _.isEmpty(this.M.education[this.M.education.length - 1].speciality) &&
              _.isEmpty(this.M.education[this.M.education.length - 1].grade)
          ) {
              this.M.education = this.M.education.slice(0, -1);
          }

          this.M.education.push(data);

          setTimeout(() => {
              if (this.$refs.univercity.slice(-2)[0] && this.$refs.univercity.slice(-2)[0].$refs.autocomplete) {
                  this.$refs.univercity.slice(-2)[0].$refs.autocomplete.type = data.education;
              }
          }, 250);
      } else {
          if (
              !!(this.M.education[index]) &&
              _.isEmpty(this.M.education[index].univercity) &&
              _.isEmpty(this.M.education[index].year) &&
              _.isEmpty(this.M.education[index].speciality) &&
              _.isEmpty(this.M.education[index].grade)
          ) {
              this.M.education[index] = data;
              this.$refs.univercity[index].$refs.autocomplete.type = data.university;
          } else {
              this.M.education.splice(index, 0, data);
          }
      }
    },
    textToEducations(text, index, explodeLines = false) {
      text = this.cutQuotes(text);

        if (explodeLines) {
            text.split('\n').forEach(line => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    this.handleEducationLine(line, index);
                }
                if (index !== null) {
                    index++;
                }
            });
        } else {
            text = text.split('\n').join(' ').trim();
            if (!_.isEmpty(text)) {
                this.handleEducationLine(text, index);
            }
        }
    },
    addEducation(focus) {
      this.M.education.push({year: '', univercity: '', speciality: '', grade: ''});

      if (focus === true) {
        if (this.$refs.univercity?.length) {
          setTimeout(() => {
            this.$refs.univercity.every((el) => {
              if (!el.$refs.autocomplete.$refs.input.value) {
                el.$refs.autocomplete.$refs.input.focus();
                return false;
              }
              return true;
            });
          }, 100);
        }
      }
    },
    removeEducation(index) {
      this.M.education.splice(index, 1);
    },
    inputEducation() {
      if (!this.M.education.at(-1)
            ||
          (this.M.education.at(-1)
          && ((this.M.education.at(-1).year !== '')
              || (this.M.education.at(-1).univercity !== '')
              || (this.M.education.at(-1).speciality !== '')
              || (this.M.education.at(-1).grade !== ''))))
        this.addEducation();
    },
    onEducationGradeSelect(newVal, index) {
      this.$refs.grade[index].$refs.multiselect.value = newVal;

      this.inputEducation();
    },
    moveEducationToCertificates: function (index) {
      // Название вуза и Специальность через пробел
      var row = this.M.education[index];

      if (
          !!(this.M.certificates[this.M.certificates.length - 1]) &&
          _.isEmpty(this.M.certificates[this.M.certificates.length - 1].univercity) &&
          _.isEmpty(this.M.certificates[this.M.certificates.length - 1].year[0])
      ) {
        this.M.certificates = this.M.certificates.slice(0, -1);
      }


      this.M.certificates.push({
        univercity: [row.univercity, row.speciality].join(' ').trim(),
        year: [row.year]
      });
      this.M.education.splice(index, 1);

      this.inputCertificateYear(this.M.certificates.length - 1);

      this.addCertificate()
    },

    addCertificate(focus = false) {
      this.M.certificates.push({univercity: '', year: ['']});
      if (this.$refs.cert && focus === true) {
        this.$refs.cert.every((el) => {
          if (el.value === '') {
            el.focus();
            return false
          }
          return true;
        });
      }

    },
    removeCertificate(index) {
      this.M.certificates.splice(index, 1);
    },
    inputCertificate() {
      if (!_.last(this.M.certificates) || _.last(this.M.certificates) && _.last(this.M.certificates).univercity !== '') {
        this.addCertificate();
      }
    },
    handleCertificateLine(line, index) {
        let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          let y = parseInt(val);
          if ((1970 <= y && y <= 2030)) {
            acc.push('' + y);
            return acc;
          } else if ((70 <= y && y <= 99)) {
            acc.push('' + (1900 + y));
            return acc;
          }
          return acc;
        }, []);

        if (index === null) {
          if (
            !!(this.M.certificates[this.M.certificates.length - 1]) &&
            _.isEmpty(this.M.certificates[this.M.certificates.length - 1].univercity) &&
            _.isEmpty(this.M.certificates[this.M.certificates.length - 1].year[0])
          ) {
            this.M.certificates = this.M.certificates.slice(0, -1);
          }

          this.M.certificates.push({
            univercity: this.cutLastComma(_.upperFirst(line).trim()),
            year: year
          });
        } else {
          this.M.certificates.splice(index, 1, {
            univercity: this.cutLastComma(_.upperFirst(line).trim()),
            year: year
          });
        }
    },
    textToCertificates(text, index, explodeLines = false) {
      text = this.cutQuotes(text);

      if (explodeLines) {
        text.split('\n').forEach(line => {
          line = line.trim();
          if (!_.isEmpty(line)) {
            this.handleCertificateLine(line, index);
          }
          if (index !== null) {
            index++;
          }
        });
      } else {
        text = text.split('\n').join(' ').trim();
        if (!_.isEmpty(text)) {
          this.handleCertificateLine(text, index);
        }
      }

      for (var i = 0; i < this.M.certificates.length; i++) {
        this.inputCertificateYear(i);
      }
    },
    onPasteCertificates(index, e) {
      let input = this.$refs.cert[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        let newText = this.replaceText(input.selectionStart, input.selectionEnd, input.value, text);
        this.M.certificates[index].univercity = _.upperFirst(newText.split('\n').join(' ').trim());
      } else {
        this.textToCertificates(text, index);
      }

      e.preventDefault();

      this.inputCertificate();
    },
    joinSimilarCertificates: function (certificates) {
      var scope = this;

      // склеиваем годы у одинаковых курсов и сертификатов
      var certificateGroups = _.groupBy(certificates, function (item) {
        return item.univercity;
      });

      var result = [];
      _.each(certificateGroups, function (certificateGroup, index) {

        var yearsArrays = _.map(certificateGroup, function (el) {
          return el.year;
        });

        var flattenYears = _.flatten(yearsArrays);
        var groupedYears = _.groupBy(flattenYears, function (item) {
          return item;
        });

        var mappedYears = _.map(groupedYears, function (item, key) {
          return (key !== '') ? item[0] : false
        });

        var filteredYears = mappedYears.filter(function (el3) {
          return el3 !== '';
        });

        var uniqYears = filteredYears.unique();
        uniqYears.push('');

        result.push({
          univercity: certificateGroup[0].univercity.trim(),
          year: uniqYears
        });
      });
      return result;
    },
    addCertificateYear(certIndex) {
      this.M.certificates[certIndex].year.push("");
    },
    removeCertificateYear(certIndex, index) {
      if (this.M.certificates[certIndex].year.length === 1) {
        if (_.isEmpty(this.M.certificates[certIndex].univercity.trim())) {
          this.removeCertificate(certIndex);
        } else {
          if (confirm('Удалить всю запись о курсе/сертификате "' + this.M.certificates[certIndex].univercity + '"?')) {
            this.removeCertificate(certIndex);
          }
        }
      } else
        this.M.certificates[certIndex].year.splice(index, 1);
    },
    inputCertificateYear(certIndex) {

      let lastYearIndex = this.M.certificates[certIndex].year.length - 1;

      if ((this.M.certificates[certIndex].year.length === 0) || (this.M.certificates[certIndex].year[lastYearIndex] !== '')) {
        this.addCertificateYear(certIndex);
      }
    },
    arrangeCertificates: function () {
      for (const [key, certificateGroup] of Object.entries(this.M.certificates)) {
        let orderedYears = certificateGroup.year.filter(year => year !== '').sort();
        this.M.certificates[key].year = orderedYears.concat('');
      }
    },
    countCertificateYears: function (certIndex) {
      return this.M.certificates[certIndex].year.length;
    },
    certificateYearText: function (certIndex) {
      return this.M.certificates[certIndex].year.map(function (el) {
        return el
      }).filter(function (el) {
        return el
      }).join(', ');
    },
    onDelete(btn) {
      if (this.currentUser.role === 'admin') {
        this.$refs.deletionDialog.$refs.dialog.show();
      } else {
          this.$modal('Вы уверены, что хотите удалить врача?', {
              name: 'Удалить',
              btnClass: 'red',
              callback: () => {
                  btn.startLoadingAnimation();

                  this.$refs.doctorEditForm.validate().then(success => {
                      if (!success) {
                          const el = document.querySelector(".hasError:first-of-type");
                          el.scrollIntoView({behavior: "smooth"});
                          btn.stopLoadingAnimation()
                          return;
                      }

                      if (this.$refs.quill.inProcess) {
                          this.$refs.quill.quillEditor.setSelection(null)
                          setTimeout(() => {
                              this.delete().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                          }, 450)
                      } else {
                          this.delete().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                      }

                  });
              }
          }, {});
      }
    },
    addAssociation(focus) {
      this.M.associations.push('');
      if (focus === true) {
        if (this.$refs.association) {
          this.$refs.association.every((el) => {
            if (el.value === '') {
              el.focus();
              return false
            }
            return true;
          });
        }
      }

    },
    removeAssociation: function (index) {
      this.M.associations.splice(index, 1);
    },
    inputAssociation() {
      if (this.M.associations.length === 0 || (this.M.associations[this.M.associations.length - 1] !== '')) {
        this.addAssociation();
      }
    },
    handleAssociationLine(line, index) {
      let data = this.cutLastComma(_.upperFirst(line).trim())
      if (index === null) {
        if (this.M.associations[this.M.associations.length - 1] === '') {
          this.M.associations[this.M.associations.length - 1] = data;
        } else {
          this.M.associations.push(data);
        }
      } else {
        this.M.associations.splice(index, 1, data);
      }
    },
    textToAssociations(text, index, explodeLines = false) {
      text = this.cutQuotes(text);

      if (explodeLines) {
        text.split('\n').forEach(line => {
          line = line.trim();
          if (!_.isEmpty(line)) {
            this.handleAssociationLine(line, index);
          }
          if (index !== null) {
            index++;
          }
        });
      } else {
        text = text.split('\n').join(' ').trim();
        if (!_.isEmpty(text)) {
          this.handleAssociationLine(text, index);
        }
      }
    },
    onPasteAssociations(index, e) {
      let input = this.$refs.association[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        text = this.replaceText(input.selectionStart, input.selectionEnd, input.value, text);
      }

      this.textToAssociations(text, index);
      e.preventDefault();

      this.inputAssociation();
    },


    // ОПЫТ РАБОТЫ
    addEmployment(focus) {
      this.M.employment.push({name: '', position: '', m1: '', y1: '', m2: '', y2: '', now: false});
      if (focus === true) {
        if (this.$refs.employment) {
          this.$refs.employment.every((el) => {
            if (el.value.length === 0) {
              el.focus();
              return false
            }
            return true;
          });
        }
      }
    },
    removeEmployment: function (index) {
      this.M.employment.splice(index, 1);
    },
    inputEmployment(validateDates = false) {
      if (validateDates) {
        this.validateEmploymentDates();
      }

      if (this.M.employment.length === 0 || (this.M.employment[this.M.employment.length - 1] !== undefined)
          && (
              (this.M.employment[this.M.employment.length - 1].name !== '')
              || (this.M.employment[this.M.employment.length - 1].position !== '')
          ))
        this.addEmployment();
    },
    handleEmploymentLine(line, index) {
      let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
        let y = parseInt(val);
        if ((1900 <= y && y <= 2050)) {
          acc.push('' + y);
          return acc;
        }
        return acc;
      }, []);

      let data = {
        name: this.cutLastComma(_.upperFirst(line).trim()),
        position: '',
        m1: '',
        y1: year[0] || '',
        m2: '',
        y2: year[1] || '',
        now: false
      };

      if (index === null) {
        this.inputEmployment();
        index = this.M.employment.length - 1;
      }

      this.M.employment[index] = this.M.employment[index] ? {
        name: data.name,
        position: data.position ? data.position : this.M.employment[index].position,
        m1: data.m1 ? data.m1 : this.M.employment[index].m1,
        y1: data.y1 ? data.y1 : this.M.employment[index].y1,
        m2: data.m2 ? data.m2 : this.M.employment[index].m2,
        y2: data.y2 ? data.y2 : this.M.employment[index].y2,
        now: data.now ? data.now : this.M.employment[index].now,
      } : data;
    },
    textToEmployments(text, index, explodeLines = false) {
      text = this.cutQuotes(text);

        if (explodeLines) {
            text.split('\n').forEach(line => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    this.handleEmploymentLine(line, index);
                }
                if (index !== null) {
                    index++;
                }
            });
        } else {
            text = text.split('\n').join(' ').trim();
            if (!_.isEmpty(text)) {
                this.handleEmploymentLine(text, index);
            }
        }

      this.M.employment = JSON.parse(JSON.stringify(this.M.employment))

      this.inputEmployment()
    },
    onPasteEmployments(index, e) {
      let input = this.$refs.employment[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        let newText = this.replaceText(input.selectionStart, input.selectionEnd, input.value, text);
        this.M.employment[index].name = _.upperFirst(newText.split('\n').join(' ').trim());
      } else {
        this.textToEmployments(text, index);
      }

      e.preventDefault();
    },
    replaceText(indexStart, indexEnd, origin, replacement) {
      return origin.substring(0, indexStart) + replacement + origin.substring(indexEnd);
    },
    onPastePosition(index, e) {
        let input = this.$refs.position[index];
        let text = e.clipboardData.getData('text/plain');

        let newText = this.replaceText(input.selectionStart, input.selectionEnd, input.value, text);
        this.M.employment[index].position = _.upperFirst(newText.split('\n').join(' ').trim());

        e.preventDefault();
    },
    onPasteSpeciality(index, e) {
      let input = this.$refs.speciality[index];
      let text = e.clipboardData.getData('text/plain');

      let newText = this.replaceText(input.selectionStart, input.selectionEnd, input.value, text);
      this.M.education[index].speciality = _.upperFirst(newText.split('\n').join(' ').trim());

      e.preventDefault();
    },
    /*** cropper functions ***/
    openCropWithNewFile(file) {
      this.$refs.cropper.preloadFile(file);
      this.$refs.cropper.showModal();
    },
    imageCropperDelete: function (event) {
      this.$modal("Удалить логотип?", {
            name: 'Удалить',
            callback: () => {
              this.M.img = '';
            }
          },
          {
            name: 'Нет'
          }
      );
    },
    imageCropperOpen() {
      if (this.M.img === '') {
        this.$refs.cropper.showFileChooser();
      } else {
        this.$refs.cropper.showModal();
      }
    },
    cropUploadSuccess(imageUrl, field) {
      this.M.img = imageUrl;
      this.M.newImgFile = null;
      this.M.oldImg = undefined;
    },
    cropCanceled: function () {
      this.M.newImgFile = null;
      if (this.M.oldImg !== undefined) {
        this.M.img = this.M.oldImg;
        this.M.oldImg = undefined;
      }
    },
    validateEmploymentDates: function () {
      let isError = false;

      for (const [key, employment] of Object.entries(this.M.employment)) {
        if (employment.now || !employment.y1 || !employment.y2) {
          document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
          continue;
        }

        let date1 = new Date(employment.y1, employment.m1 - 1, 1);
        let date2 = new Date(employment.y2, employment.m2 - 1, 1);

        if (date2 < date1) {
          document.querySelectorAll('.employments input.year2')[key].classList.add('attentionValidationOnSubmitError');
          isError = true;
        } else {
          document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
        }
      }

      return isError;
    },

    infoTooltip() {
      return `<div class="tooltip-content">
                        <table>
                            <tr><td>Описание:         </td><td>` + this.M.ratingInternalDetailed.hasInfo + `            &nbsp;×&nbsp;10000    </td></tr>
                            <tr><td>Фото:             </td><td>` + this.M.ratingInternalDetailed.hasImg + `            &nbsp;×&nbsp;5000     </td></tr>
                            <tr><td>Подх.отзывы:      </td><td>` + this.M.ratingInternalDetailed.hasShowInFeedRatings + ` &nbsp;×&nbsp;1000×Кол  </td></tr>
                            <tr><td>Анкета:           </td><td>` + this.M.ratingInternalDetailed.hasUserAccount + `      &nbsp;×&nbsp;500       </td></tr>
                            <tr><td>Есть фотографии:  </td><td>` + this.M.ratingInternalDetailed.hasPhotos + `           &nbsp;×&nbsp;250       </td></tr>
                            <tr><td>Имя и отчество:   </td><td>` + this.M.ratingInternalDetailed.hasFullFio + `          &nbsp;×&nbsp;200       </td></tr>
                            <tr><td>Цена приема:      </td><td>` + this.M.ratingInternalDetailed.hasPrice + `           &nbsp;×&nbsp;100       </td></tr>
                            <tr><td>Образование:      </td><td>` + this.M.ratingInternalDetailed.hasEducation + `       &nbsp;×&nbsp;25        </td></tr>
                            <tr><td>Стаж:             </td><td>` + this.M.ratingInternalDetailed.hasExperience + `       &nbsp;×&nbsp;25        </td></tr>
                            <tr><td>Опыт работы:      </td><td>` + this.M.ratingInternalDetailed.hasEmployment + `      &nbsp;×&nbsp;5         </td></tr>
                            <tr><td>Курсы/сертификаты:</td><td>` + this.M.ratingInternalDetailed.hasCertificates + `     &nbsp;×&nbsp;5         </td></tr>
                            <tr><td>Ассоциации:       </td><td>` + this.M.ratingInternalDetailed.hasAssociations + `    &nbsp;×&nbsp;1         </td></tr>
                        </table>
                     </div>`;
    },
    onPasteFamilyName(value) {
      this.fioCheckDuplicate(_.toLower(value));
    },
    onBlurFio() {
      if (_.words(this.M.nameFamily).length >= 3) {
        this.fioCheckDuplicate(this.M.nameFamily);
      } else if (this.M.nameFamily && this.M.nameFirst && this.M.nameFathers) {
        this.fioCheckDuplicate(this.M.nameFamily.trim() + ' ' + this.M.nameFirst.trim() + ' ' + this.M.nameFathers.trim());
      }
    },

    fioUpcaseFirst() {
      this.M.nameFamily = _.capitalize(this.M.nameFamily, true);
      this.M.nameFirst = _.capitalize(this.M.nameFirst, true);
      this.M.nameFathers = _.capitalize(this.M.nameFathers, true);
    },

    fioCheckDuplicate(fio) {
      fio = _.words(fio).join(' ');

      if (this.duplicateLastSearchedFio.toLowerCase().replace(/\./g, '') !== fio.toLowerCase().replace(/\./g, '') && this.M.id === '') {
        this.duplicateLastSearchedFio = fio;

        this.axios.post('doctors/checkDuplicate', {fio: fio}).then((resp) => {
          if(resp.data.nameFamily) {
            this.$nextTick( () => {
              this.M.nameFamily = resp.data.nameFamily;
              this.M.nameFirst = resp.data.nameFirst;
              this.M.nameFathers = resp.data.nameFathers;
              this.M.sex = resp.data.sex;
            });
          }

          if (resp.data.status === 'DUPLICATE') {
            this.$refs.duplicateDialog.show(resp.data.doctors);
          }

          this.fioUpcaseFirst();

        });
      }
    },

    editSpecialities() {
      this.$refs.specialitiesDialog.$refs.dialog.show();
    },
    resetComponentData() {
      Object.assign(this.$data, initialState());
    },


//____________________________________

    onclose() {
      if(!_.isEqual(this.M,this.M_clone)){
        if (confirm('Закрыть?')) {
          this.$refs.dialog.hide();
        }
      }else{
        this.$refs.dialog.hide();
      }

    },
    onSelectDuplicateDoctor(id) {
      this.read(id, null, true);
    },
    read: function (id, e = null, isDuplicate = false) {
      this.resetComponentData();

      this.isDuplicate = isDuplicate;

      return this.axios.get('doctors/read/' + id, {}).then(response => {

        Vue.set(this, 'M', response.data);
        this.inputEducation()
        this.inputEmployment();
        this.inputCertificate();
        for (let i = 0; i < this.M.certificates.length; i++) {
          this.inputCertificateYear(i);
        }
        this.inputAssociation();
        if(this.currentUser.role !== 'network') {
          delete(this.M.networkClinics);
        }
        setTimeout( () => {
          this.M_clone = JSON.parse(JSON.stringify(this.M));
        },400);

        this.actionType = 'update';

        this.$refs.dialog.show();

        setTimeout(() => {
          this.Mhashcode = JSON.stringify(this.M).hashCode();
        }, 500)


      })

    },

    onUpdate(btn) {
        if(!this.needSave){
            return;
        }
      this.netInvalidShowFlag = true;
      if(this.currentUser.role === 'network' && this.M.networkClinics.filter((item) => item.checked === true).length === 0) {
        return;
      }
      if (this.validateEmploymentDates()) {
        return;
      }

      btn.startLoadingAnimation();

      this.$refs.doctorEditForm.validate().then(success => {
        if (!success) {
          const el = document.querySelector(".hasError:first-of-type");
          el.scrollIntoView({behavior: "smooth"});
          btn.stopLoadingAnimation()
          return;
        }

        if (this.$refs.quill.inProcess) {
          this.$refs.quill.quillEditor.setSelection(null)
          setTimeout(() => {
            this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
          }, 450)
        } else {
          this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
        }

      });
    },

    delete() {
      this.netInvalidShowFlag = true;
      if(this.currentUser.role === 'network' && this.M.networkClinics.filter((item) => item.checked === true).length === 0) {
        return;
      }
      return this.axios.post('doctors/delete/' + this.M.id, this.M).then(() => {
        this.hideAndRefresh()
      }).catch((error) => {
      });
    },
    hideAndRefresh () {
      this.$refs.dialog.hide();
      this.$parent.$refs.table.update();
    },
    update() {
      if (this.actionType === 'create'){
        return this.axios.post('doctors/create', this.M).then(() => {
          this.hideAndRefresh()
        }).catch((error) => {
        });
      }else{
        return this.axios.post('doctors/update/' + this.M.id, this.M).then(() => {
          this.hideAndRefresh()
        }).catch((error) => {
        });
      }
    },
    cutQuotes(text) {
      if (text[0] === '«' && text[text.length - 1] === '»') {
        text = text.slice(1, text.length - 1);
      }

      return text;
    },
    cutLastComma(text) {
      if (text[text.length - 1] === ',') {
        text = text.slice(0, text.length - 1);
      }

      return text;
    },
      photosUploaded(uploadedImageUrls, position){
          uploadedImageUrls.reverse().forEach((url) => {
              this.M.photos.splice(position,0,url)
          })
      }
  },
}
</script>

<style lang="scss">
#doctorEdit {
  max-width: 950px !important;
}

.hidden-url {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.deleted {
  text-decoration: line-through black;
}

.option-list .option:not(:last-child):after {
  content: ',';
}

#doctorEdit .onmoderation,
#doctorEdit .warning {
  background-color: rgba(255, 255, 0, 0.22) !important;
  border-right: 1px solid rgba(229, 230, 0, 0.22) !important;
}

#doctorEdit .ql-textToList:after {
  content: "\f0ca";
  padding-right: 10px;
  font-size: 15px;
  margin-top: -2px;
}

.ql-textLowerCase {
  width: 42px !important;
}

.ql-textToEducations {
  margin-top: -3px !important;
  width: 50px !important;
}

.ql-textToCertificates {
  margin-top: -3px !important;
  width: 50px !important;
}

.ql-textToEmployments {
  margin-top: -3px !important;
  width: 50px !important;
}

.ql-textToAssociations {
  margin-top: -3px !important;
  width: 50px !important;
}

.ql-textTemplate1 {
  margin-top: -3px !important;
  width: 102px !important;
}

#doctorEdit .multiselect__single {
  max-width: 665px;
}

#doctorEdit .ql-toolbar .ql-formats:nth-child(2) {
  float: right;
  padding-right: 0;
  margin-right: 0;
}

#doctorEdit .ql-textLowerCase:after {
  content: "A→а";
  display: block;
  top: 0;
  padding-left: 10px;
}

#doctorEdit .ql-textToEducations:after {
  content: "→Обр";
  display: block;
  top: 0;
  padding-left: 10px;
}

#doctorEdit .ql-textToCertificates:after {
  content: "→Курс";
  display: block;
  top: 0;
  padding-left: 10px;
}

#doctorEdit .ql-textToEmployments:after {
  content: "→Раб";
  display: block;
  top: 0;
  padding-left: 10px;
}

#doctorEdit .ql-textToAssociations:after {
  content: "→Асс";
  display: block;
  top: 0;
  padding-left: 10px;
}

#doctorEdit .ql-textTemplate1:after {
  content: "Проф навыки";
  padding-right: 10px;
  display: block;
  top: 0;
}
#doctorEdit .multiselect__tags span,
#doctorEdit .multiselect__tags
{
    background-color: #fff0 !important;
}
#doctorEdit .networkFIO
{
    display: block;
    height: 27px;
}
.certificateYearBlock {
  margin-right: 5px;
}
#doctorEdit .photo-container .copyBtn {
    right: 30px !important;
}
</style>
